import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";
//import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _ from "lodash";
import autoBind from "react-autobind";

import * as playerActions from "../../actions/playerActions";

import CanvasDraw from "react-canvas-draw";

import {transformSketchPadDataForPlayer} from "../../utils/transformUtils";

let instanceCount = 0;

class SketchPadSimple extends PureComponent {
	constructor(props) {
		super(props);

		this.handleToggleScroll = this.handleToggleScroll.bind(this);
		instanceCount++;
		// console.log("Modal Logbook constructor");
		this.sketchPadRef = React.createRef();
		this.sketchPadContainerRef = React.createRef();

		this.onResize = this.onResize.bind(this);
		this.onResizeDebounced = _.debounce(this.onResize, 500);

		autoBind(this);

		this.state = {
			toggleScroll: false,
			autoResize: true,
			sketchPadData: transformSketchPadDataForPlayer(props.item)
		};
	}

	handleToggleScroll() {
		const toggleScroll = !this.state.toggleScroll;
		this.setState({
			toggleScroll
		});
	}

	handleToggleAutoResize() {
		const autoResize = !this.state.autoResize;
		this.setState({
			autoResize,
			toggleScroll: false
		});
	}

	componentDidMount() {

		let self = this;

		window.globalCanvas = this.sketchPadRef.current;

		if (!_.isEmpty(this.state.sketchPadData)) {
			let sketchPadDataStr = JSON.stringify(this.state.sketchPadData);
			//console.log(sktechPadDataStr);

			self.setState({
				canvasWidth: self.state.sketchPadData.width,
				canvasHeight: self.state.sketchPadData.height,
				autoResize: false
			});

			setTimeout(() => {
				self.sketchPadRef.current.loadSaveData(sketchPadDataStr, true);			
			},200);
		} else {
			this.onResize();
		}
		
		window.addEventListener("resize", this.onResizeDebounced);
	}

	componentWillUnmount() {
		if (this.props.hasOwnProperty("itemIndices")) {
			let self = this;
			self.props.dispatch(playerActions.saveSketchPad);
		}

		window.removeEventListener("resize", this.onResizeDebounced);
	}

	onResize() {
		if (this.state.autoResize) {
			let sketchPadContainer = this.sketchPadContainerRef.current;

			this.setState({
				canvasWidth: sketchPadContainer.offsetWidth - 20,
				canvasHeight: sketchPadContainer.offsetHeight - 40
			});
		}
	}

	render() {
		let self = this;

		let disableToggleScroll = this.state.autoResize ? true : false;
		const toggleScrollClass = disableToggleScroll ? "text-button-disabled" : "";
		
		const backgroundColor = (this.props.backgroundColor) ? this.props.backgroundColor : "white";
		return (
			<div ref={this.sketchPadContainerRef} style={{ display: "flex", flexDirection: "column", padding: 10, flex: 1, height: "100%", width: "100%" }}>
				<div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: 6 }}>
					<div style={{ cursor: "pointer", color: "#0071fe"}}
						onClick={(e) => {
							if (self.sketchPadRef.current) {
								self.sketchPadRef.current.undo();
							}
						}}>Undo</div>
					<div style={{ cursor: disableToggleScroll ? "": "pointer", color: "#0071fe" }} className={ toggleScrollClass }
						onClick={(e) => {
							if (!disableToggleScroll) {
								this.handleToggleScroll();
							}
						}}>{this.state.toggleScroll ? "Switch To Draw" : "Switch To Scroll"}</div>
					<div style={{ cursor: "pointer", color: "#0071fe" }}
						onClick={(e) => {
							this.handleToggleAutoResize();
						}}>{this.state.autoResize? "Switch To Fixed Size" : "Switch To Auto Resize"}</div>
					<div style={{ cursor: "pointer", color: "#0071fe" }}
						onClick={(e) => {
							if (self.sketchPadRef.current) {
								self.sketchPadRef.current.clear();
								this.props.dispatch(playerActions.clearSketchPadImage, this.props.onClear);
							}
						}}>Clear</div>
				</div>
				<div style={{ height: "100%", width: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", flex: 1, overflowX: this.state.toggleScroll ? "auto" : "hidden", overflowY: this.state.toggleScroll ? "auto" : "hidden" }}>				
					<div style={{ position: "relative", width: "100%", height: "100%" }}>				
						<CanvasDraw
							ref={this.sketchPadRef}
							key={`canvas-${instanceCount}`}
							style={{ borderStyle: "solid", borderWidth: 0, borderColor: "black", backgroundColor }}
							canvasWidth={this.state.canvasWidth}
							canvasHeight={this.state.canvasHeight}
							brushColor={this.props.penColor && !_.isEmpty(this.props.penColor) ? this.props.penColor : "black"}
							brushRadius={_.isNumber(this.props.penWidth) && this.props.penWidth > 0 ? this.props.penWidth / 2 : 2.5} /* need to use half pen width to match mobile stroke value */
							hideGrid={true}
							lazyRadius={0}
							/>						
					</div>
				</div>
			</div>
		);
	}
}

export default branch({
}, SketchPadSimple);


